import {ReportForm} from "@/types/ReportForm.ts";

interface HeaderProps {
  reportForm: ReportForm;
}

export const Header = ({reportForm}: HeaderProps) => {
  return (
    <div className="flex items-center mb-8">
      {reportForm.logo_url ? (
        <img src={reportForm.logo_url} alt="logo" className="w-12 h-12 rounded-md mr-4"/>
      ) : null
      }
      <h1 className="text-xl font-semibold text-gray-700">
        Report Security Vulnerabilities at {reportForm.workspace_name}
      </h1>
    </div>
  );
}
